import React, { useState } from "react";
import actu from "../../assets/img/actu.jpg";
export default function Actualite({ actualite }) {
  console.log(actualite,"actue");
  return (
    <div className="col-md-3 col-sm-6 mb-4">
      <div
        style={{
          height: "350px",
          position: "relative",
          cursor: "pointer",
          borderRadius: "0px",
          overflow: "hidden",
          backgroundImage: `url(${actu})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition:
            "filter 0.3s ease-in-out, background-color 0.3s ease-in-out",
        }}
      >
        {/* Contenu affiché au survol */}
        <div
          className="position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center"
          style={{
            backgroundColor: "#2854a0b6",
            color: "white",
            textAlign: "center",
            opacity: 0,
            transition: "opacity 0.3s ease-in-out",
          }}
          onMouseOver={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseOut={(e) => (e.currentTarget.style.opacity = 0)}
        >
          <p>{actualite.contenu}</p>
          <a
            href={actualite.lien} // Lien vers une autre page
            style={{
              color: "white",
              textDecoration: "none",
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              fontSize: "18px",
              transition: "color 0.3s ease-in-out",
            }}
          >
            Voir plus <span style={{ fontSize: "20px" }}>&rarr;</span>
          </a>
        </div>

        {/* Titre en bas */}
        <div
          className="position-absolute w-100 text-center py-2 bg-claire w-100 text-white"
          style={{
            bottom: 0,
          }}
        >
          <h6 className="m-0">{actualite.titre}</h6>
        </div>
      </div>
    </div>
  );
}

export function ActualiteVideo({ actualite }) {
  const [isHovered, setIsHovered] = useState(true);

  return (
    <div className="col-md-3 col-sm-6 mb-4">
      <div
        style={{
          height: "350px",
          position: "relative",
          cursor: "pointer",
          borderRadius: "0px",
          overflow: "hidden",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Contenu affiché au survol */}
        <div
          className="position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center"
          style={{
            backgroundColor: "#2854a0b6",
            color: "white",
            textAlign: "center",
            opacity: isHovered ? 0 : 1,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <p>{actualite.contenu}</p>
        </div>

        {/* Vidéo */}
        <div
          className="position-relative w-100 h-100"
          style={{
            backgroundColor: "black",
          }}
        >
          <video
            src={actualite.video}
            controls
            loop
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Titre en bas au survol */}
        <div
          className="position-absolute w-100 text-center py-2 bg-claire text-white"
          style={{
            bottom: "0", // Masque le titre lorsque le survol n'est pas actif
            transition: "bottom 0.3s ease-in-out",
          }}
        >
          <h6 className="m-0">{actualite.titre}</h6>
        </div>
      </div>
    </div>
  );
}
